import { ReleaseNotesQueryParams } from '@/api/apis/release-notes';

export const opobffReleaseNotesQueryKeys = {
  all: ['opobff-release-notes'] as const,
  list: (params?: ReleaseNotesQueryParams) => ['opobff-release-notes', 'list', params] as const,
};
